import React, { memo } from "react";
import { CircularProgress } from "@mui/material";

const ButtonProgress = ({ size, color = "#fff" }) => {
  const style = {
    color,
    width: size,
    height: size,
  };
  return <CircularProgress style={style} />;
};

export default memo(ButtonProgress);
